export const getFaviconFromUrl = (url: string, size: 64 | 32 | 16 = 64): string => {
  if (!url) return "";

  try {
    const { hostname, protocol } = new URL(url);

    // Prefer same-origin favicon if possible
    const baseUrl = `${protocol}//${hostname}`;
    const directFavicon = `${baseUrl}/favicon.ico`;

    // Use Google's favicon service as a fallback with desired size
    const googleFavicon = `https://www.google.com/s2/favicons?domain=${hostname}&sz=${size}`;

    // We return Google favicon service by default since it's more reliable.
    // Consumers can decide to fall back to direct favicon if the Google one fails to load.
    return googleFavicon || directFavicon;
  } catch {
    return "";
  }
};

// Non-persistent helper: derive favicons from saved URLs on the fly
export function attachFaviconsToSources<T extends { url?: string; faviconUrl?: string }>(
  sources: T[] | undefined,
  size: 64 | 32 | 16 = 32
): (T & { faviconUrl?: string })[] {
  if (!Array.isArray(sources)) return [];
  return sources.map((s) => {
    if (s.faviconUrl) return s as T & { faviconUrl?: string };
    const fav = s.url ? getFaviconFromUrl(s.url, size) : "";
    return { ...s, ...(fav ? { faviconUrl: fav } : {}) } as T & { faviconUrl?: string };
  });
}

export function getDirectFaviconUrl(url: string): string {
  try {
    const u = new URL(url);
    return `${u.protocol}//${u.hostname}/favicon.ico`;
  } catch {
    return "";
  }
}
